module.exports = __webpack_public_path__ + "static/media/schedule_structure_remove_a_rotating_period.971a7b85.mov";